<template>

    <b-container style="flex: available">
        <b-row>
            <b-col>
                <b-img src="../assets/napa_green_land.jpg"></b-img>
            </b-col>
            <b-col>
                <b-img src="require('@/assets/napa_green_winery.jpg')"></b-img>
            </b-col>
        </b-row>
        <b-container style="margin-top: 25px">
            <p> Thank you for submitting your information. You will be receiving an email shortly about next steps to
                become Napa Green Land certified. If you have any questions please reach out to
              the Napa Green team, at <a
                  href="mailto:team@napagreen.org">team@napagreen.org</a>. </p>
        </b-container>
    </b-container>


</template>
<script>
    export default {
        data() {
            return {}
        },
        methods: {}
    }
</script>
